import React from "react";
import { Typography, Grid, Box } from "@mui/material";
import { useResponsive } from "../../hooks/use-responsive";

export default function HeroFive() {

  const mdUp = useResponsive("up", "md");


  return (

    <Grid
      container
      spacing={3}
      sx={{ justifyContent: "center", alignContent: "center" }}
    >
      {mdUp && (
        <Grid item xs={12} md={6}>
          <Typography
            component="span"
            className="HeroHeading"
          >
            IS YOUR CHILD LOSING FOCUS &nbsp;<span className="HeroHighlighted"  >FROM LEARNING?</span>
          </Typography>

          <Box justifyContent='center' alignItems='center' mt='28px' >
            <Typography className="heroText" >
              With MegaConnect, you can make your child's screen time more productive. Easily monitor their activities with our app to encourage learning and creativity!
            </Typography>
          </Box>

        </Grid>
      )}
      {mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/home_hero_five.svg"
            alt="home_hero_five"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/home_hero_five_sm.svg"
            alt="home_hero_five"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && (
        <Grid item xs={12} md={7} textAlign="center" >
          <Typography
            component="span"
            className="HeroHeading"
            textAlign={'center'}
          >
            IS YOUR CHILD LOSING FOCUS &nbsp;<span className="HeroHighlighted"  >FROM LEARNING?</span>
          </Typography>

          <Box sx={{
            // mt: '18px',
            minHeight: '106px', // Set a minimum height for the Box
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}  >
            <Typography textAlign='center' className="heroText"
            >
              With MegaConnect, you can make your child's screen time more productive. Easily monitor their activities with our app to encourage learning and creativity!
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  )
}
